import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    ApplyPromotionCodeToSubscriptionRequest,
    ApplyPromotionCodeToSubscriptionResponse
} from "./types";

export { apiName };

const applyPromotionCodeToSubscription = getCallable<ApplyPromotionCodeToSubscriptionRequest, ApplyPromotionCodeToSubscriptionResponse>(
    apiName,
    "applyPromotionCodeToSubscription",
    {
        ...endpoints.applyPromotionCodeToSubscription,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/promotion-code`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

export const callables = {
    applyPromotionCodeToSubscription
};
